/* eslint-disable jsx-a11y/interactive-supports-focus */
import { ROUTER_PERSONAL_DASHBOARD } from '@App/Studio/Modules/Personal/Dashboard/configs/const'
import { ROUTER_WORKSPACE_EXAM } from '@App/Studio/Modules/Workspace/Exam/configs/const'
import { Collapse, Fade, Typography } from '@mui/material'
import { isFunction } from 'lodash'
import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
// import PropTypes from 'prop-types'

const AppLogo = ({ collapsed, onClick, bizapp }) => {
	const navigate = useNavigate()

	const handleClick = () => {
		if (isFunction(onClick)) {
			onClick()
		} else {
			navigate(ROUTER_PERSONAL_DASHBOARD.dashboard)
		}
	}

	const renderLogo = () => {
		return (
			<div className="w-[160px]">
				<img src="/assets/images/logo_text.png" alt="EduQuiz.io" title="EduQuiz.io" />
			</div>
		)
	}

	return (
		<div role="button" className="flex items-center gap-2 px-3 py-2 cursor-pointer" onClick={handleClick}>
			{renderLogo()}
		</div>
	)
}

// AppLogo.defaultProps = {}

// AppLogo.propTypes = {}

export default React.memo(AppLogo)
